import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import getTabBarIcon from '@shared/components/navigation/TabBarIcon';
import AnimatedTabBar from '@shared/components/navigation/AnimatedTabBar';
import { MODULE_ROUTES, ModuleRoute } from './routeRegistry';
import tabNavigatorStyle from '@assets/styles/tabNavigatorStyles';
import { TAB_TOUR_ANCHORS, TourAnchor } from 'app/_modules/onboarding';

const Tab = createBottomTabNavigator();

function sortAndFilterTabRoutes(routes: ModuleRoute[]) {
  return routes
    .filter(r => r.meta.placement === 'tab')
    .sort((a, b) => (a.meta.order ?? 100) - (b.meta.order ?? 100));
}
export const AppTabs: React.FC = () => {
  const tabRoutes = useMemo(() => sortAndFilterTabRoutes(MODULE_ROUTES), []);

  return (
    <Tab.Navigator
      tabBar={props => (
        <AnimatedTabBar
          {...props}
          renderTabAnchor={routeName => {
            const anchor = TAB_TOUR_ANCHORS[routeName];
            return anchor ? (
              <TourAnchor anchor={anchor} style={styles.anchorFill}>
                <View style={styles.anchorFill} />
              </TourAnchor>
            ) : null;
          }}
        />
      )}
      screenOptions={({ route }) => ({
        headerShown: false,
        tabBarIcon: ({ focused, color, size }) => getTabBarIcon(route.name, focused, color, size),
        animation: 'fade',
        animationDuration: 250,
      })}>
      {tabRoutes.map(({ id, Stack, meta }) => (
        <Tab.Screen
          key={id}
          name={id}
          component={Stack}
          options={{
            tabBarLabel: meta.tabLabel ?? id,
            tabBarIcon: ({ color, size, focused }) => {
              if (typeof meta.tabIcon === 'function') {
                const Icon = meta.tabIcon;
                return <Icon color={color} size={size} focused={focused} />;
              }
              return getTabBarIcon(meta.tabIcon, focused, color, size);
            },
            ...tabNavigatorStyle.tabBarItem
          }}
        />
      ))}
    </Tab.Navigator>
  );
};

const styles = StyleSheet.create({
  anchorFill: {
    flex: 1,
  },
});

export default AppTabs;
